import { render, staticRenderFns } from "./LandingAdvantages.vue?vue&type=template&id=765a1c40&scoped=true"
import script from "./LandingAdvantages.vue?vue&type=script&lang=js"
export * from "./LandingAdvantages.vue?vue&type=script&lang=js"
import style0 from "./LandingAdvantages.vue?vue&type=style&index=0&id=765a1c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765a1c40",
  null
  
)

export default component.exports